/* eslint-disable import/prefer-default-export */

export enum DocTypes {
  TenOThreeFinal = "1003_final",
  TenOThreeInitial = "1003_initial",
  TenOEightFinal = "1008_final",
  TenOEightAndUnderwritingSummary = "1008_and_underwriting_summary",
  TenNinetyNine = "1099",
  FortyFiveOSixTInitial = "4506t_initial",
  FortyFiveOSixCInitial = "4506c_initial",
  AccurateGroupResponse = "accurate_group_response",
  AcknowledgementOfAppraisalReceipt = "acknowledgement_of_appraisal_receipt",
  AcknowledgementOfCfpbBooklets = "acknowledgement_of_cfpb_booklets",
  AdverseActionNotice = "adverse_action_notice",
  Allonge = "allonge",
  Appraisal_1004d = "appraisal_1004d",
  Appraisal1004dInvoice = "appraisal_1004d_invoice",
  AppraisalDeskReview = "appraisal_desk_review",
  AppraisalFieldReview = "appraisal_field_review",
  AppraisalInvoice = "appraisal_invoice",
  AppraisalMismo = "appraisal_mismo",
  AppraisalReport = "appraisal_report",
  AppraisalSSRFannie = "appraisal_ssr_fannie",
  AppraisalSSRFreddie = "appraisal_ssr_freddie",
  AssetOther = "asset_other",
  AssetReport = "asset_report",
  AssetSummary = "asset_summary",
  BalanceSheet = "balance_sheet",
  BankUnitedWarehouseFundingTape = "bank_united_warehouse_funding_tape",
  BankruptcyDocuments = "bankruptcy_documents",
  BirthCertificate = "birth_certificate",
  BorrowersAuthorization = "borrowers_authorization",
  CharmBooklet = "charm_booklet",
  CpaLetterBusinessLicense = "cpa_letter_business_license",
  ChildSupportAlimonyDebt = "child_support_alimony_debt",
  ChildSupportAlimonyIncome = "child_support_alimony_income",
  ClosingPackage = "closing_package",
  ClosingProtectionLetter = "closing_protection_letter",
  ComplianceFeesTest = "compliance_fees_test",
  ConditionalApprovalLetter = "conditional_approval_letter",
  ConditionAttachment = "condition_attachment",
  CorrespondenceBorrower = "correspondence_borrower",
  CorrespondenceVendor_3rdPartyProvider = "correspondence_vendor_3rd_party_provider",
  CreditOther = "credit_other",
  CreditReport = "credit_report",
  CreditSupplement = "credit_supplement",
  CustodianTape = "custodian_tape",
  DesktopOriginator = "desktop_originator",
  DesktopUnderwriterFindings = "desktop_underwriter_findings",
  DesktopUnderwriterStatusLog = "desktop_underwriter_status_log",
  DesktopUnderwriterFindingsXML = "desktop_underwriter_findings_xml",
  DeathCertificate = "death_certificate",
  DownpaymentAssistanceLetter = "downpayment_assistance_letter",
  EarnestMoneyDeposit = "earnest_money_deposit",
  EarthquakePolicy = "earthquake_policy",
  EmploymentContractOfferLetter = "employment_contract_offer_letter",
  ExplanationAttachment = "explanation_attachment",
  FNMA32 = "fnma32",
  FinalClosingDisclosure = "final_closing_disclosure",
  FinalTitlePolicy = "final_title_policy",
  FirstTimeHomebuyerEducationCertificate = "first_time_homebuyer_education_certificate",
  FloodCertificate = "flood_certificate",
  FloodPolicy = "flood_policy",
  FundingTape = "funding_tape",
  GiftFundsEvidence = "gift_funds_evidence",
  GiftLetter = "gift_letter",
  GiftLetterTemplate = "gift_letter_template",
  GoodbyeLetter = "goodbye_letter",

  // NOTE: jjw: GoodbyeLetterTransferOfServicing no longer selectable in UI; superseded by:
  // -- GoodbyeLetter
  // -- HOITransferOfServicing
  // type remains here until we choose to migrate older documents to two new types
  GoodbyeLetterTransferOfServicing = "goodbye_letter_transfer_of_servicing",

  Ho6InsurancePolicy = "ho6_insurance_policy",
  HoaCondoDocs = "hoa_condo_docs",
  HoaDues = "hoa_dues",
  HoaMasterFloodInsurancePolicy = "hoa_master_flood_insurance_policy",
  HoaMasterHomeownersInsurancePolicy = "hoa_master_homeowners_insurance_policy",
  HOITransferOfServicing = "hoi_transfer_of_servicing",
  HomeInspectionReport = "home_inspection_report",
  HomeLoanToolkitBooklet = "home_loan_toolkit_booklet",
  HomeownersPolicy = "homeowners_policy",
  Income = "income",
  IncomeOther = "income_other",
  IncomeMilitary = "income_military",
  IncomeMilitaryResidual = "income_military_residual",
  IncomeSummary = "income_summary",
  IncomeSelfEmployed = "income_self_employed",
  InitialClosingDisclosure = "initial_closing_disclosure",
  InitialDisclosurePackage = "initial_disclosure_package",
  InitialLoanEstimate = "initial_loan_estimate",
  InvestorExceptionVarianceApproval = "investor_exception_variance_approval",
  InvestorLoanApproval = "investor_loan_approval",
  InvestorPostclosingPackage = "investor_postclosing_package",
  InvestorPrefundingPackage = "investor_prefunding_package",
  InvestorRateLock = "investor_rate_lock",
  InvestorSuspenseConditions = "investor_suspense_conditions",
  K1 = "k_1",
  LawsuitJudgment = "lawsuit_judgment",
  LetterOfExplanationAsset = "letter_of_explanation_asset",
  LetterOfExplanationCredit = "letter_of_explanation_credit",
  LetterOfExplanationIncome = "letter_of_explanation_income",
  LoanDetailReport = "loan_detail_report",
  LoansafeAppraisalManagerReport = "loansafe_appraisal_manager_report",
  LoansafeAppraisalManagerXml = "loansafe_appraisal_manager_xml",
  LoansafeFraudManagerReport = "loansafe_fraud_manager_report",
  LoansafeFraudManagerXml = "loansafe_fraud_manager_xml",
  MersRegistration = "mers_registration",
  MersTransfer = "mers_transfer",
  ManuallyEditedDisclosure = "manually_edited_disclosure",
  MarriageLicense = "marriage_license",
  MessageAttachment = "message_attachment",
  MortgageInsuranceCertificate = "mortgage_insurance_certificate",
  MortgageInsuranceQuote = "mortgage_insurance_quote",
  MortgageInsuranceStatementOfDenial = "mortgage_insurance_statement_of_denial",
  MortgageStatement = "mortgage_statement",
  Unused = "unused",
  NonPermanentResidentVisa = "non_permanent_resident_visa",
  Note = "note",
  NoticeOfIncompleteApplication = "notice_of_incomplete_application",
  OriginWarehouseTape = "origin_warehouse_tape",
  PaymentFromBorrower = "payment_from_borrower",
  PaymentHistoryStatement = "payment_history_statement",
  PayoffDemandStatement = "payoff_demand_statement",
  Paystub = "paystub",
  PermanentResidentCardVisa = "permanent_resident_card_visa",
  PestInspection = "pest_inspection",
  PhotoIdentification = "photo_identification",
  PlaidTransactionHistory = "plaid_transaction_history",
  PostClosingPayoffStatement = "post_closing_payoff_statement",
  PowerOfAttorney = "power_of_attorney",
  PrequalPackageAuditTrail = "prequal_package_audit_trail",
  PrequalPackageCertificate = "prequal_package_certificate",
  PreAppLoanEstimate = "pre_app_loan_estimate",
  ProfitAndLossStatement = "profit_and_loss_statement",
  PurchaseAdvice = "purchase_advice",
  PurchaseContract = "purchase_contract",
  ReoAvm = "reo_avm",
  ReoEstimatedSettlementStatement = "reo_estimated_settlement_statement",
  ReoExpenses = "reo_expenses",
  ReoFinalSettlementStatement = "reo_final_settlement_statement",
  ReoPendingSalePropertyContract = "reo_pending_sale_property_contract",
  RateLockAgreement = "rate_lock_agreement",
  RateLockAgreementCertificate = "rate_lock_agreement_certificate",
  RateLockTape = "rate_lock_tape",
  ReceiptOfFundsToClose = "receipt_of_funds_to_close",
  RecordedSecurityInstrument = "recorded_security_instrument",
  RelocationAgreement = "relocation_agreement",
  RentalReoLease = "rental_reo_lease",
  RetirementPensionIncome = "retirement_pension_income",
  RevisedLoanEstimate = "revised_loan_estimate",
  Ssa89 = "ssa_89",
  SatisfactionOfJudgementLienLawsuit = "satisfaction_of_judgement_lien_lawsuit",
  SecurityInstrument = "security_instrument",
  ServiceLinkResponse = "service_link_response",
  ServicingTape = "servicing_tape",
  SettlementStatementEstimated = "settlement_statement_estimated",
  SettlementStatementFinal = "settlement_statement_final",
  ShippingLabel = "shipping_label",
  SocialSecurityCard = "social_security_card",
  SocialSecurityIncome = "social_security_income",
  SSNVerification = "ssn_verification",
  Statement = "statement",
  StockOptionAwardVestingLetter = "stock_option_award_vesting_letter",
  SubjectPropertyAvm = "subject_property_avm",
  SubjectPropertyOther = "subject_property_other",
  SubjectPropertyReport = "subject_property_report",
  TaxCertificate = "tax_certificate",
  TaxReturn1065Partnership = "tax_return_1065_partnership",
  TaxReturn1120CCorp = "tax_return_1120_c_corp",
  TaxReturn1120sSCorp = "tax_return_1120s_s_corp",
  TaxReturnTranscript1065Partnership = "tax_return_transcript_1065_partnership",
  TaxReturnTranscript1120CCorp = "tax_return_transcript_1120_c_corp",
  TaxReturnTranscript1120sSCorp = "tax_return_transcript_1120s_s_corp",
  TaxTranscript = "tax_transcript",
  TitleCommitment = "title_commitment",
  TitleEO = "title_e&o",
  TitleOther = "title_other",
  TrustAgreementOrCertification = "trust_agreement_or_certification",
  UCDFannie = "ucd_fannie",
  UCDFreddie = "ucd_freddie",
  ULIRegistration = "uli_registration",
  UnderwritingLoanApproval = "underwriting_loan_approval",
  UnderwritingSummary = "underwriting_summary",
  Unknown = "unknown",
  VACertificateOfEligibility = "va_certificate_of_eligibility",
  VerbalVerificationOfEmployment = "verbal_verification_of_employment",
  VerificationOfMortgage = "verification_of_mortgage",
  VerificationOfRent = "verification_of_rent",
  W2 = "w2",
  W2Transcript = "w2_transcript",
  W9 = "w9",
  WindAndHailPolicy = "wind_and_hail_policy",
  WireInstructions = "wire_instructions",
  WorknumberVerbalEmploymentVerification = "worknumber_verbal_employment_verification",
  WorknumberEmploymentVerification = "worknumber_employment_verification",
  WrittenVerificationOfEmployment = "written_verification_of_employment",
  WvoeCertificate = "wvoe_certificate",
  IncomeTaxReturn2013 = "income_tax_return_2013",
  IncomeTaxReturn2014 = "income_tax_return_2014",
  IncomeTaxReturn2015 = "income_tax_return_2015",
  IncomeTaxReturn2016 = "income_tax_return_2016",
  IncomeTaxReturn2017 = "income_tax_return_2017",
  IncomeTaxReturn2018 = "income_tax_return_2018",
  IncomeTaxReturn2019 = "income_tax_return_2019",
  IncomeTaxReturn2020 = "income_tax_return_2020",
  IncomeTaxReturn2021 = "income_tax_return_2021",
  ChildCareLetter = "child_care_letter",
  NPSCreditReport = "nps_credit_report",
}

export enum OwnerEntityTypes {
  Account = "account",
  Employment = "employment",
  AdditionalIncome = "additional_income",
  OwnedRealEstate = "owned_real_estate",
}
